<template>
    <div class="container-fluid">
        <h3 class="mb-2">Settings</h3>
        <b-tabs>
            <b-tab v-for="tab in tabs" :title="tab.name" @click="goTo(tab.url)"></b-tab>
        </b-tabs>
        <section>
            <router-view keep-alive></router-view>
        </section>
    </div>
</template>
<script>
    export default {
        name: 'Settings',
        data,
        methods: {
            isActive,
            goTo
        }
    };


    function data() {
        const session = this.$store.state.session;
        const commonTabs = [
            {
                name: 'Profile',
                url: '/account/profile',
            },
        ];
        return {
            tabs: commonTabs,
        };
    }

    function isActive(tab) {
        return this.$route.path.indexOf(tab.url) !== -1;
    }

    function goTo(url) {
        this.$router.push({path: url});
    }
</script>
